// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1946) return "static/chunks/1946-604fa86af85fe2b3.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"806":"4163ae0c","2831":"b5c69090"}[chunkId] || chunkId) + "." + {"806":"e5b4b87355ad4985","2227":"31ae9fdb89c306ba","2277":"a23a67bee069916c","2831":"d8e2790a7cea7439","3665":"0a0a7eabb2fc797f","4001":"09fbde954e9d0ddf","8497":"b8a163f9a185f55f"}[chunkId] + ".js";
};